import { Autocomplete, SelectChangeEvent, TextField } from '@mui/material'
import React, { SyntheticEvent, useEffect, useRef, useState } from 'react'
import ConfigurationHeader from '../../components/heading/ConfigurationHeader'
import Input, { DashboardCheckbox, DashboardSelect } from '../../components/Input/Input'
import { configurationAttributeType, newConfigurationNames, customerConfigurationValuesTypes } from '../../types'
import "./CustomerConfiguration.css"
import { popupType } from '../../types/types'
import { convertValuesToConfig, createValidation, doFinalConfigSubmit, getMetaDataConfig, getNewConfiguration, overWriteConfig, postConfiguration, updateConfiguration } from '../../services/uiConfigService'
import * as yup from 'yup'
import store from '../../stateManagement/store'
import { GenericPopUp } from '../../components/popup/genericPopUp'
import * as countryModule from "countries-and-timezones"
import { objectKeys } from '../../utils/utils'
import * as Sentry from "@sentry/react";
import { IndentWrapper } from '../orderConfiguration/OrderConfiguration'
import QuestionHeading from '../../components/heading/QuestionHeading'
import { validateWithOtp } from '../../stateManagement/actions/validateOtpPopupActions'
import { manageUpdateAccessObj } from '../manageUpdateAccess/manageUpdateAccessTypes'
import { openPopup } from '../../stateManagement/actions/popupActions'
import { initialCustomerValues } from '../defaultConfigurations/customerConfigDefaultValues'
import { deepClone } from '@mui/x-data-grid/utils/utils'
import { countryDialCodeMapping } from './countryDialCodeMapping'
import ConfigComparePopup from '../../components/popup/ConfigComparePopup'
import ImportConfig from '../../components/importConfig/ImportConfig'
const data = require('currency-codes/data');



const CustomerConfiguration = () => {
    const [customerConfig, setCustomerConfig] = useState<configurationAttributeType[]>([]);
    const [values, setValues] = useState<customerConfigurationValuesTypes>(deepClone(initialCustomerValues))
    const [customerValidationsSchema, setCustomerValidationSchema] = useState({})
    const [clientTimeZoneOption, setClientTimeZoneOption] = useState<string[]>([])
    const [countryCodeOptions, setCountryCodeOptions] = useState<{ title: string, value: string }[]>([])
    const [currencyCodesOptions,setCurrencyCodesOption] = useState<string[]>([]);

    const [showConfigPopup,setShowConfigPopup] = useState<boolean>(false);
    const curConfigRef = useRef<{[key:string]:any[]}>({});
    const newConfigRef = useRef<{[key:string]:any[]}>({});

    const getcustomerConfiguration = async () => {
        try {

            const resp = await getNewConfiguration('customer_configuration');
            const customer_config: configurationAttributeType[] = resp?.domainValues;
            curConfigRef.current.customer_configuration = customer_config ?? [];
            setCustomerConfig([...customer_config])
        } catch (err) {
            // Sentry.captureException(err);
        }
    }

    useEffect(() => {
        try {
            const allCurrencyCodes = data.map((currencyObj: any) => {
                return currencyObj.code;
            })
            setCurrencyCodesOption(allCurrencyCodes);
            let countries = countryModule.getAllCountries();
            const keys = objectKeys(countries);
            const options = [] as { title: string, value: string }[]
            keys.forEach((key) => {
                options.push({ title: countries[key].name, value: countries[key].id })
            })
            setCountryCodeOptions(options);
        } catch (err) {
            // Sentry.captureException(err);
        }
        
        getcustomerConfiguration();
    }, [])


    const saveConfiguration = async (preview?: boolean) => {
            try {
                const customerSchema = yup.object({ ...customerValidationsSchema })
                const validationObject:any = {};
                Object.keys(values).forEach(key=>{
                    validationObject[key] = values[key].value;
                })
                // await customerSchema.validate(validationObject)
                const convertedVals = convertValuesToConfig(values, customerConfig);
                newConfigRef.current.customer_configuration = convertedVals;
                setShowConfigPopup(true);
            } catch (err) {
                // Sentry.captureException(err);
                console.log("err===", err)
                if (err instanceof Error)
                    openPopup('Error',"Validation Error occured : " + err?.message)
            }
        
    }
    const handleCountryCodeValueChange = (e: SelectChangeEvent<unknown>) => {
        const keyName = e.target.name;
        const countryName = countryModule.getCountry(e.target.value  as string)?.name ?? "" ;
        const preFilledDialCode = countryDialCodeMapping[countryName]?.toString() ?? "";
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.value, isValueUpdated:true},
            dialCode: {...values["dialCode"], value: preFilledDialCode, isValueUpdated:true} 
        })
    }
    const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.value, isValueUpdated:true} 
        })
    }

    const handleSelectValueChange = (e: SelectChangeEvent<unknown>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.value, isValueUpdated:true} 
        })
    }

    const handleCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.checked, isValueUpdated:true} 
        })
    }

    const handleCurrencyChange = (e: SyntheticEvent,value: string | null) => {
        if(value) setValues({
            ...values,
            currency: {...values["currency"], value, isValueUpdated: true},
            currencySymbol: {...values["currencySymbol"],value, isValueUpdated: true}
        })
    }

    const setCustomerConfigValues = () => {
        try {

            if (customerConfig.length) {
                const temp = { ...values };
                const result = { ...initialCustomerValues } as { [key: string]: unknown }
                const resValidations = {} as { [key: string]: ReturnType<typeof createValidation> }
                customerConfig.forEach((attr) => {
                    resValidations[attr.name] = createValidation(attr)
                    result[attr.name] = attr;
                })
                setValues({ ...result as customerConfigurationValuesTypes });
                setCustomerValidationSchema({ ...resValidations })
            }
        } catch (err) {
            // Sentry.captureException(err);
        }
    }

    useEffect(() => {
        setCustomerConfigValues();
    }, [customerConfig])

    useEffect(() => {
        try {
            const timeZones = countryModule.getTimezonesForCountry(values.countryCode.value);
            if (timeZones?.length)
                setClientTimeZoneOption(timeZones.map(tZ => tZ.name))
        } catch (err) {
            // Sentry.captureException(err);
        }
    }, [values.countryCode])


  const importConfiguration = async (importedConfig:any)=>{
    const newConfigs = await overWriteConfig(importedConfig, {
        // customer_configuration:["countryCode","clientTimeZone","dialCode","numberFormat","currency","currencySymbol","supportNumber"]
        customer_configuration:"importAll"
    })
    newConfigs.forEach((item) => {
        newConfigRef.current[item.domainType] = item.domainValues;
    });
    setShowConfigPopup(true);
  }

  const  onConfigComparatorSuccess=async () => {
    await doFinalConfigSubmit("customer_configuration",newConfigRef.current.customer_configuration,curConfigRef)
    getcustomerConfiguration();
  }

  const [importConfigState,setImportConfigState] = useState(false);


    return (
        <div className="customer_config_container">
            <ImportConfig importConfigState={importConfigState} setImportConfigState={setImportConfigState} configNames={['customer_configuration']} importConfigCallback={importConfiguration} />
            <ConfigurationHeader heading={"Customer Configuration"} saveConfiguration={() => saveConfiguration(false)} />
            <div className="config_form_container">

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Select the Country Code
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardSelect value={values.countryCode.value} onChange={handleCountryCodeValueChange} name="countryCode" options={countryCodeOptions} selectLableId='Country Code' />
                    </div>
                </IndentWrapper>

                {values.countryCode && <> <IndentWrapper indent={2}>
                    <QuestionHeading>
                        Select the time zone
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardSelect onChange={handleSelectValueChange} value={values.clientTimeZone.value} name="clientTimeZone" options={clientTimeZoneOption} selectLableId='clientTimeZone' />
                    </div>
                </IndentWrapper>

                    <IndentWrapper indent={2}>
                        <QuestionHeading>
                            Enter the Dial Code
                        </QuestionHeading>
                        <div className="answer_container">
                            <Input name="dialCode" value={values.dialCode.value} onChange={handleValueChange} />
                        </div>
                    </IndentWrapper> </>}


                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Select the format of the number
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardSelect onChange={handleSelectValueChange} value={values.numberFormat.value} name="numberFormat" options={values.numberFormat.possibleVals} selectLableId='numberFormat' />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Select the currency
                    </QuestionHeading>
                    <div className="answer_container">
                        <Autocomplete
                            className='customer_config_currency_selector'
                            disablePortal
                            disableClearable
                            options={currencyCodesOptions}
                            value={values.currency.value}
                            onChange={handleCurrencyChange}
                            renderInput={(params) => <TextField {...params}  />}
                        />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Select the currency symbol
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input name="currencySymbol" value={values.currencySymbol.value} onChange={handleValueChange} />
                    </div>
                </IndentWrapper>


                <IndentWrapper indent={0}>
                    <QuestionHeading>
                        Enter support number
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input name="supportNumber" type={'tel'} value={values.supportNumber.value} onChange={handleValueChange} />
                    </div>
                </IndentWrapper>
                <IndentWrapper indent={0}>
                    <QuestionHeading>
                    external App DeepLink
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input name="externalAppDeepLink" type={'tel'} value={values?.externalAppDeepLink?.value} onChange={handleValueChange} />
                    </div>
                </IndentWrapper>

                <IndentWrapper indent={1}>
                    <QuestionHeading>
                        chatGpt Enabled
                    </QuestionHeading>
                    <div className="answer_container">
                        <DashboardCheckbox onChange={handleCheckChange} checked={values?.chatGptEnabled?.value} name="chatGptEnabled" label="Yes" />
                    </div>
                </IndentWrapper>


            </div>
            <ConfigComparePopup message="Are you sure want to update the config" showConfigPopup={showConfigPopup} setShowConfigPopup={setShowConfigPopup} curConfig={curConfigRef.current} newConfig={newConfigRef.current} onSuccess={onConfigComparatorSuccess} />
        </div>
    )
}

export default CustomerConfiguration